// Material definition as stored in map files (docs/ARCHITECTURE.md, "Map file format").
// Mirrors the Rust/JSON schema exactly; the map renderer feeds these into createSurfaceMaterial().

export type Color = string; // "#rrggbb"

export type TextureKind =
  | "plain"
  | "concrete"
  | "tiles"
  | "panel"
  | "metal"
  | "grate"
  | "stripes"
  | "glass"
  | "wood"
  | "asphalt";

export interface MaterialDef {
  color: Color;
  texture: TextureKind;
  /** Meters per texture repeat. Geometry UVs already carry it, so material textures repeat once per UV unit. */
  uvScale: number;
  roughness: number;
  metalness: number;
  /** 0..1 */
  grime: number;
  emissive?: Color;
  emissiveIntensity?: number;
  /** < 1 = transparent */
  opacity?: number;
}

export const TEXTURE_KINDS: readonly TextureKind[] = [
  "plain",
  "concrete",
  "tiles",
  "panel",
  "metal",
  "grate",
  "stripes",
  "glass",
  "wood",
  "asphalt",
];

/** Weapon camo ids (gr-core `CamoId`). */
export type CamoName = "none" | "carbon" | "hazard" | "arctic" | "ember" | "prism" | "gold";

export const CAMO_NAMES: readonly CamoName[] = [
  "none",
  "carbon",
  "hazard",
  "arctic",
  "ember",
  "prism",
  "gold",
];
